import { FC } from "react";

import { Tooltip, useTheme } from "@mui/material";
import { CloudArrowDownIcon } from "@phosphor-icons/react/dist/csr/CloudArrowDown";
import { CloudArrowUpIcon } from "@phosphor-icons/react/dist/csr/CloudArrowUp";
import { useNavigator } from "../../lib/Hooks";
import { Spacer } from "../ui/common";
import { IconButton } from "../ui/icons";

interface AssetProps {
  name: string;
  type: string;
  suspendType?: string;
  causedBy?: {
    name?: string;
    type?: string;
  };
  groupBy?: string;
  project?: string;
  line?: number;
}

interface LinksHelperProps {
  search?: string;
  link_text?: string;
  file_path?: string;
  import_name?: string;
  export_name?: string;
  key_name?: string;
  asset?: AssetProps;
  changelistId?: string;
}

const LinkDownloadsByImport: FC<LinksHelperProps> = ({ import_name }) => {
  const nav = useNavigator();
  return (
    <Tooltip id="tooltip" title={`View Downloads for Import: ${import_name}`}>
      <IconButton onClick={() => nav.goto("downloads/list", { import_name })}>
        <CloudArrowDownIcon />
      </IconButton>
    </Tooltip>
  );
};

const LinkUploadsByProject: FC<LinksHelperProps> = ({ file_path, link_text }) => {
  const nav = useNavigator();
  const theme = useTheme();
  return (
    <Tooltip id="tooltip" title={`View Uploads for Project: ${file_path}`} placement="bottom" arrow>
      <IconButton
        data-cy="tooltip-container-uploads-link"
        onClick={() => nav.goto("uploads/list", { project_id: file_path })}
      >
        <CloudArrowUpIcon size="24px" color={theme.palette.text50.main} />
        {link_text ? <Spacer>{link_text}</Spacer> : null}
      </IconButton>
    </Tooltip>
  );
};

export { LinkDownloadsByImport, LinkUploadsByProject };
